import { useSession } from "@amtana/auth-client";

// S12.01: the platform app's one read of the session's permissions, installed with
// `withPermissionsSource` in auth.web.ts. The router gates a screen naming `requiresPermission`
// (the back office's) and the shell's navigation on it: undefined while the session loads, the
// live set after, empty while signed out. Impersonating staff carry a viewer's set, so the back
// office disappears for the length of a visit.

export function useSessionPermissions(): readonly string[] | undefined {
  return useSession().data?.permissions;
}
